import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BUTTONS_TEXT, PRIMARY_BUTTONS } from './constants/action-button';
import { IconNames } from '../../common/constants/icon-names';
import { CamelCasePipe } from '../../common/pipes/camel-case.pipe';
import { ButtonAction, ButtonSize, ButtonType } from './constants';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-action-button',
  imports: [MatButtonModule, CommonModule, TranslateModule, CamelCasePipe, SvgIconComponent],
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ActionButtonComponent implements OnInit {
  @Input() text: string;
  @Input() action: ButtonAction;
  @Input() testId: string;
  @Input() disabled = false;
  @Input() size: ButtonSize = ButtonSize.M;
  @Input() set type(type: ButtonType) {
    this.type$.next(type);
  }
  @Output() buttonClick = new EventEmitter<void>();

  buttonAction = ButtonAction;
  buttonType = ButtonType;
  currentButtonType$: Observable<ButtonType>;
  primaryButtons = PRIMARY_BUTTONS;
  buttonsText = BUTTONS_TEXT;
  iconNames = IconNames;

  private type$ = new BehaviorSubject<ButtonType | null>(null);

  get classByAction(): { [key: string]: boolean } {
    return {
      [this.action && this.action.toLowerCase() + '-button']: Boolean(this.action),
    };
  }

  ngOnInit(): void {
    this.currentButtonType$ = this.type$.pipe(
      map((type: ButtonType) => {
        return type ? type : this.primaryButtons.includes(this.action) ? ButtonType.Primary : ButtonType.Secondary;
      }),
    );
  }
}
